import { Component, Input } from '@angular/core';

import { BannerSectionCms } from '~/cms/interfaces/homepage.cms.interface';

@Component({
  selector: 'app-cms-banner-section',
  templateUrl: './banner-section.component.html',
})
export class CmsBannerSectionComponent {
  @Input() public banner: BannerSectionCms;
  @Input() public isHp?: boolean;
}
